import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

import { GameMetaDataMap } from '../lobby-details-model/game-metadata.model';

@Injectable({
    providedIn: 'root',
})
export class GameManagerService {
    gameMetaDataMap: Map<string, GameMetaDataMap> = new Map<string, GameMetaDataMap>();
    gameMetaDataPlayerStatsSubject = new BehaviorSubject<Map<string, GameMetaDataMap> | null>(null);
    gameMetaDataPlayerStatsObservable: Observable<number> = this.gameMetaDataPlayerStatsSubject.asObservable().pipe(
        map((arr) => (arr ? arr.size : 0)),
        distinctUntilChanged(),
    );

    getGameInfo(gameId: string): GameMetaDataMap | null {
        if (!this.gameMetaDataMap) {
            return null;
        }
        return this.gameMetaDataMap.get(gameId) ?? null;
    }

    getGameDisplayName(gameId: string): string {
        if (!this.gameMetaDataMap) {
            return '';
        }
        return this.gameMetaDataMap.get(gameId)?.name ?? '';
    }

    setGameIconNotFound(gameId: string, iconType: number = 1): void {
        const gameInfo: GameMetaDataMap | null = this.gameMetaDataMap?.get(gameId) || null;
        if (gameInfo && !gameInfo.isImageNotFound) {
            gameInfo.isImageNotFound = new Map();
            gameInfo.isImageNotFound.set(iconType.toString(), true);
        }
    }

    isGameIconNotAvailable(gameId: string, iconType: number = 1): boolean {
        if (!this.gameMetaDataMap) {
            return false;
        }
        const gameInfo: GameMetaDataMap | null = this.gameMetaDataMap.get(gameId) || null;
        if (gameInfo?.isImageNotFound && gameInfo?.isImageNotFound?.size > 0) {
            return gameInfo.isImageNotFound.get(iconType.toString()) || false;
        }
        return false;
    }

    updateMetaData(gameMetaDataMap: Map<string, GameMetaDataMap>): void {
        if (gameMetaDataMap) {
            this.gameMetaDataMap = gameMetaDataMap;
            this.gameMetaDataPlayerStatsSubject.next(gameMetaDataMap);
        }
    }
}
